import React, { useEffect } from 'react';
import { Box, Typography, Button } from '@mui/material';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getOtpMode, setVerifySecurityCode } from '../../../../Store/UsersAccount/userAccount.slice.selector';
// import { getOtpMode } from '../../store/users';

const ThankYou = ({ forgotType, urlData, buttonName }) => {
  const otpmedium = useSelector(getOtpMode)
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(setVerifySecurityCode(""))
  }, [])
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        padding: 4,
        // backgroundColor: '#f0f0f0',
        borderRadius: '8px',
        // boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
      }}
    >
      <Typography variant="h5" sx={{ fontWeight: 600, mb: 2 }}>
        Thank you, Your request has been accepted.
      </Typography>
      <Typography variant="body1" sx={{ mb: 1 }}>
        If the information entered is correct, your reset password link
        has been sent
        to the specified 
        {/* {otpmedium} */}
        &nbsp; email.
      </Typography>
      <Typography variant="body1" sx={{ mb: 3 }}>
        Please check your email address and return to the sign in page.
      </Typography>
      <Button
        component={Link}
        to="/login"
        variant="contained"
        color="primary"
        sx={{
          width: '100%',
          mb: 2,
          backgroundColor: "#f5365c",
          borderColor: "#f5365c",
          '&:hover': {
            backgroundColor: '#f5365c',
            color: 'white',
            border: 'none',
          }
        }}
      >
        RETURN TO SIGN IN PAGE
      </Button>
    </Box>
  );
};

export default ThankYou;
